function helperNewDate () {
  return new Date()
}

module.exports = helperNewDate



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/date/helperNewDate.js
// module id = 183
// module chunks = 106